var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.busquedas},scopedSlots:_vm._u([{key:"item.timestamp",fn:function(ref){
var item = ref.item;
return [_c('p',{staticClass:"text-capitalize"},[_vm._v(" "+_vm._s(_vm.formatDate(item.timestamp.toDate()))+" ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }